import { render, staticRenderFns } from "./OrderLogistics.vue?vue&type=template&id=4da73c4d&scoped=true"
import script from "./OrderLogistics.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderLogistics.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OrderLogistics.vue?vue&type=style&index=0&id=4da73c4d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da73c4d",
  null
  
)

export default component.exports